<template>
  <v-container>
    <v-dialog v-model="dialogmembresia" max-width="800px">
      <v-card>
        <v-card-title class="headline">Número de membresía</v-card-title>
        <v-card-text>
          En tu tarjeta digital o contrato puedes encontrar el número de
          membresía.
        </v-card-text>
        <v-img :src="imageSrc1" cover class="bg-grey-lighten-2"></v-img>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="dialogmembresia = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpass" max-width="800px">
      <v-card>
        <v-card-title class="headline">¿Cuál es mi contraseña?</v-card-title>
        <v-card-text>
          Tu contraseña corresponde a la siguiente combinación:
        </v-card-text>
        <v-img :src="imageSrc2" cover class="bg-grey-lighten-2"></v-img>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="dialogpass = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-center>
      <v-flex xs12 sm8 md4>
        <div class="text-center mb-6">
          <h1 class="grey--text text--darken-1 font-weight-light">Bienvenido</h1>
          <v-img src="https://medicover.mx/img/login-user.png" max-height="140" contain
            class="mx-auto my-4 rounded-lg"></v-img>
          <v-divider></v-divider>
        </div>
        <h3 class="grey--text"> Ingresa tus credenciales</h3>
        <br />
        <form @submit.prevent="login">
          <v-text-field outlined clearable dense v-model="numMem" :rules="membresiaRule" label="Número de membresía"
            @input="validamembresia" @change="validamembresia" required
            hint="Ingrese número de membresía en automatico se quitarán los espacios, (-)." persistent-hint
            append-outer-icon="mdi-help-circle-outline" @click:append-outer="openModal1"></v-text-field>
          <v-text-field outlined clearable dense label="Contraseña" :type="showPassword ? 'text' : 'password'"
            :rules="contrarquerido" v-model="password" required :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility" append-outer-icon="mdi-help-circle-outline"
            @click:append-outer="openModal2"></v-text-field>
          <v-alert dense text type="error" v-if="this.mostrarerror">
            {{ this.errormensaje }}
          </v-alert>
          <v-row no-gutters justify="center" class="">
            <v-col cols="12" class="text-center">
              <v-btn :href="WhatsApp" target="_blank" text small color="grey darken-1" class="font-weight-medium"
                style="text-transform: none;">
                ¿Necesitas ayuda para iniciar sesión?
              </v-btn>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <br />
          <div class="d-flex flex-column justify-space-between align-center">
            <v-btn color="azul_med" depressed elevation="2" large outlined rounded type="submit">
              Iniciar sesión</v-btn>
          </div>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import CryptoJS from "crypto-js";
export default {
  name: 'LoginView',
  validations: {
  },
  data: () => ({
    numMem: null,
    membresiaRule: [
      (v) => !!v || "Número de Membresía es requerido",
      (v) =>
        /^[a-zA-Z0-9]{1,36}$/.test(v) ||
        "Valor inválido no debe incluir (-) ni espacios en blanco",
    ],

    isImageLoaded1: false,
    imageSrc1: "https://medicover.mx/img/ayuda/img1.png",
    isImageLoaded2: false,
    imageSrc2: "https://medicover.mx/img/ayuda/img2.png",
    dialogpass: false,
    dialogmembresia: false,
    mykey: process.env.VUE_APP_API_SECRETKEY || '',

    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Hola, necesito ayuda al iniciar sesión como usuario ')}`,
    email: '',
    mostrarerror: false,
    errormensaje: null,
    emailRules: [
      (v) => !!v || 'Correo requerido',
      (v) => /.+@.+\..+/.test(v) || 'Correo invalido'
    ],
    password: '',
    showPassword: false,
    contrarquerido: [
      (v) => !!v || "Contraseña requerida",
      (v) =>
        (v && v.length === 8) ||
        "La contraseña debe tener exactamente 8 caracteres", // Longitud exacta
    ],
  }),
  computed: {
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      // !this.$v.checkbox.checked && errors.push('You must agree to continue!');
      return errors
    },
    selectErrors() {
      const errors = []
      if (!this.$v.select.$dirty) return errors
      // !this.$v.select.required && errors.push('Item is required');
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
      // !this.$v.name.required && errors.push('Name is required.');
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      // !this.$v.email.email && errors.push('Must be valid e-mail');
      // !this.$v.email.required && errors.push('E-mail is required');
      return errors
    }
  },
  created() {
    this.$store
      .dispatch('logout', {})
  },
  beforeMount() {
  },
  mounted() {
  },

  methods: {
    openModal1() {
      this.isImageLoaded1 = false; // Reinicia el estado
      const img = new Image();
      img.src = this.imageSrc1;
      img.onload = () => {
        this.isImageLoaded1 = true; // Marca que la imagen ya cargó
        this.dialogmembresia = true; // Muestra el modal
      };
    },
    openModal2() {
      this.isImageLoaded2 = false; // Reinicia el estado
      const img = new Image();
      img.src = this.imageSrc2;
      img.onload = () => {
        this.isImageLoaded2 = true; // Marca que la imagen ya cargó
        this.dialogpass = true; // Muestra el modal
      };
    },
    validamembresia() {
      if (!this.numMem) {
        this.numMem = "";
        return;
      }

      // Convertir a mayúsculas, quitar espacios y filtrar caracteres no alfanuméricos
      this.numMem = this.numMem
        .toUpperCase()
        .trim()
        .split('')
        .filter(char => /^[A-Z0-9]$/.test(char))
        .join('');
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      // this.$refs.form.validate();
    },
    encryptPassword() {
      if (this.mykey.length === 32) {
        // Generar un IV aleatorio
        const iv = CryptoJS.lib.WordArray.random(16);

        // Encriptar la contraseña
        const encrypted = CryptoJS.AES.encrypt(
          this.password,
          CryptoJS.enc.Utf8.parse(this.mykey),
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        );

        // Combinar IV y texto cifrado
        const encryptedData = iv
          .concat(encrypted.ciphertext)
          .toString(CryptoJS.enc.Base64);

        return encryptedData;
      }
    },
    async login() {
      this.$store
        .dispatch("iniciosesion", {
          IdTarjeta: this.numMem,
          Password: this.encryptPassword(),
          tipo: 'cliente'
        })
        .then((response) => {
          console.log(response)
          // this.$router.replace(this.$route.query.redirect || '/');
          //this.$router.replace(this.$route.query.redirect || response);
          this.$router.replace('/user/micuenta');
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.mostrarerror = true;
            this.errormensaje = "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente más tarde.";
          } else {
            this.mostrarerror = true;
            this.errormensaje =
              "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente más tarde.";
          }
        });
    },
    submit() {
      this.$v.$touch()
    },
    clear() {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    }
  }
}
</script>
<style lang="scss" scoped></style>